var AdaptiveImage = require( "../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/img_brand_banner_gradient.9c24de23.png","uri@2x": __webpack_public_path__ + "static/media/img_brand_banner_gradient.ace6ab71.png","uri@3x": __webpack_public_path__ + "static/media/img_brand_banner_gradient.1a574d47.png",
    width: 375,
    height: 120
});